import React from 'react'
import RenderBtn from './RenderBtn';
import { useTranslation } from 'react-i18next';

function NavBar() {
  const {t} = useTranslation('global');  
  return (
    <>
         <div>
          <RenderBtn to="/home"> {t('home')}</RenderBtn>
          <RenderBtn to="/users"> {t('users')}</RenderBtn>
          <RenderBtn to="/progress"> {t('progress')}</RenderBtn>
          <RenderBtn to="/programs"> {t('programs')}</RenderBtn>
          <RenderBtn to="/alerts"> {t('alerts')}</RenderBtn>
          </div>
    </>
  )
}

export default NavBar